<template>
  <div class="country-input-wrapper">
    <div class="dropdown" :class="{ active: target }" v-click-outside="() => handleClickOutside()">
      <div class="selected-country" @click="target = !target;" v-for="country in selectCode">
        <div class="country-flag">
          {{ country.emoji }}
        </div>
        <svg class="arrow-list" width="7.255112" height="4.252197" viewBox="0 0 7.25511 4.2522" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs/>
          <path id="Vector" d="M6.62 0.62L3.62 3.62L0.62 0.62" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round" stroke-linecap="round"/>
        </svg>
        <div class="country-code">{{ country.dial_code }}</div>
      </div>
      <div class="dropdown-list" v-if="target">
        <div class="list-item" v-for="country in countries" @click="changeCode(country.code); target = false;">
          {{ country.emoji }}
          <div class="code">{{ country.dial_code }}</div>
        </div>
      </div>
    </div>
    <input class="input-phone" type="text" id="phone" v-model="inputValue" v-maska="bindedObject" @input="emitInputData" :placeholder="bindedObject.mask_placeholder" />
  </div>
</template>

<script>
import countryCodeData from '@/assets/json/CountryPhoneMask.json';
import { vMaska } from "maska/vue"
export default {
  name: 'VueCountryIntl',
  directives: { maska: vMaska },
  props: {
    phone: String,
  },
  data() {
    return {
      countries: countryCodeData,
      bindedObject: {
        mask: "+93-##-###-####",
        completed: false,
      },
      selectCode: {},
      target: false,
      inputValue: "",
      formattedPhoneNumber: "",
    }
  },
  methods: {
    handleClickOutside(){
      this.target = false;
    },
    changeCode(value) {
      this.selectCode = this.countries.filter(country => country.code === value);
      this.bindedObject.mask = this.selectCode[0].mask;
      this.bindedObject.mask_placeholder = this.selectCode[0].mask_placeholder;
      this.target = false;
    },
    emitInputData() {
      if (this.bindedObject.mask.length == this.inputValue.length) {
        this.$emit('update:modelValue', this.inputValue);
      }
      else this.$emit('update:modelValue', '');
    },
  },
  mounted() {
    this.changeCode(this.countries[0].code);
  },
}
</script>

<style scoped>
input{
  border: none;
  outline: none;
}
.country-input-wrapper{
  display: flex;
  box-sizing: border-box;
  border: 1px solid rgb(222, 230, 234);
  border-radius: 8px;
  background: rgb(255, 255, 255);
  height: 44px;
  gap: 12px;
}

.country-input-wrapper.error{
  border-radius: 8px;
  border: 1.5px solid var(--Red-200, #EA2313);
}
.dropdown {
  position: relative;
  display: flex;
  gap: 4px;
  padding-left: 17px;
}

.dropdown.active {
  border-radius: 8px 8px 0 0;
}

.selected-country {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--Gray-300, #888);
  font-family: Standerd;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  /* 142.857% */
}

.dropdown-list {
  position: absolute;
  top: 87%;
  left: -1.3px;
  width: calc(100% + 30px);
  background-color: #fff;
  border-radius: 8px;
  border: 2px solid var(--Gray-stroke, #E5E5EA);
  border-top: unset;
  max-height: 150px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 2;
  border-radius: 0px 0px 8px 8px;
}

.dropdown-list .list-item {
  display: flex;
  cursor: pointer;
  padding: 0 10px;
  gap: 4px;
  color: var(--Gray-300, #888);
  font-family: Standerd;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  /* 142.857% */
}

.dropdown-list .list-item:last-child {
  padding-bottom: 10px;
}

</style>